import React from 'react'
import { PhoneNumber } from 'libphonenumber-js'
import { PhoneIcon } from '@toasttab/buffet-pui-icons'
import Link from 'src/shared/components/common/link'
import useTracker from 'src/lib/js/hooks/useTracker'
import { useCompletedOrder } from 'src/public/components/online_ordering/OrderContext'
import { useRestaurant } from 'src/shared/components/common/restaurant_context/RestaurantContext'
import { getDisplayBusinessName } from 'src/shared/js/locationUtils'
import { TrackingEvents } from 'src/shared/components/common/tracking/TrackingEvents'
import { t } from 'src/translations/src'

interface Props {
  parsedPhoneNumber: PhoneNumber
}

// Default "Need help?" card: contact the restaurant by phone.
export const NeedHelpPhoneCard = ({ parsedPhoneNumber }: Props) => {
  const { completedOrder } = useCompletedOrder()
  const { selectedLocation } = useRestaurant()
  const tracker = useTracker()

  return (
    <div className='getInTouchContainer'>
      <div className='getInTouch'>
        <div className='textContent'>
          <h3>{t('order-confirmation.behavior.get-in-touch.header')}</h3>
          <p>
            {t('order-confirmation.behavior.get-in-touch.subtitle', {
              restaurantName: getDisplayBusinessName(
                completedOrder?.restaurant?.name,
                selectedLocation?.name
              )
            })}
          </p>
        </div>
        <Link
          className='getHelpButton'
          href={`tel:${parsedPhoneNumber.number}`}
          data-testid='get-in-touch-button'
          onClick={() =>
            tracker.track(TrackingEvents.PHONE_NUMBER_CLICKED, {
              context: 'order_confirmation_link',
              restaurant_guid: completedOrder?.restaurant?.guid ?? ''
            })
          }
        >
          <PhoneIcon
            accessibility='semantic'
            aria-label={t('order-confirmation.behavior.get-in-touch.call')}
          />
          {parsedPhoneNumber.formatNational()}
        </Link>
      </div>
    </div>
  )
}
